// extracted by mini-css-extract-plugin
module.exports = {"bgDark":"styles-module--bgDark--3qx9M","bgLight":"styles-module--bgLight--zNDDR","mainSections":"styles-module--mainSections--TOO_1"};